import React, { useState, useRef, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';

import { Link } from '@reach/router';
import { itemDateColor } from '../../../services/utils';
import { Menu } from 'react-feather';
import styles from '../Writes.module.scss';
import { BOOK_STATUS } from '../../../services/utils/constants';
import { ARCHIVE_RESTORE_BOOKS, DELETE_BOOK } from '../services/graphql';
import { GET_TEACHER_BOOKS } from '../../Dashboard/services/graphql';
import { Modal } from '@squirrellearningltd/go-teacher-components';

const WriteItem = ({ book }) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const [archiveRestoreBook, {loading: archiveBookLoading}] = useMutation(ARCHIVE_RESTORE_BOOKS, {
        variables: {
            classBookIds: [book.id],
            archived: !book.archived,
        },
        onError: () => {
            alert('The book could not be archived. Please try again.')
        },
        refetchQueries: [{ query: GET_TEACHER_BOOKS }],
        awaitRefetchQueries: true,
    });

    const [
        deleteBook,
        {
            loading: deleteBookLoading,
            error: deleteBookError
        },
    ] = useMutation(DELETE_BOOK, {
        variables: {
            classBookId: book.id,
        },
        refetchQueries: [{ query: GET_TEACHER_BOOKS }],
        awaitRefetchQueries: true,
    });

    const ref = useRef(null);
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () =>
            document.removeEventListener('click', handleClickOutside, true);
    }, []);

    return (
        <>
            <div className={`${styles.write} col-lg-4 col-md-6`}>
                <div className={styles.writeType}>
                    <Menu
                        onClick={() => setDropdownVisible(!dropdownVisible)}
                        className='dropdownHolder'
                        size='24'
                    />
                    {dropdownVisible && (
                        <ul
                            ref={ref}
                            className='dropdownMenu dropdownMenuRight'
                        >
                            <li
                                onClick={() => archiveRestoreBook()}
                                className={`dropdownMenuItem ${archiveBookLoading ? styles.disabled : ''}`}
                            >
                                {book.archived ? 'Restore' : 'Archive'} project
                            </li>
                            <li
                                onClick={() => {
                                    setShowDeleteConfirmation(
                                        !showDeleteConfirmation
                                    );
                                }}
                                className='dropdownMenuItem'
                                style={{ color: '#ff0000' }}
                            >
                                Delete project
                            </li>
                        </ul>
                    )}
                </div>
                <Link to={`/book/${book.id}`} className='card card-hover'>
                    <div
                        className={styles.writeContent}
                        style={{
                            background: itemDateColor(book.createdAt),
                        }}
                    >
                        <h2 className={styles.writeTitle}>
                            {book.bookTemplate?.name}
                        </h2>
                        <p className={styles.writeTitleClass}>
                            {book.studentsClass?.name}
                        </p>
                        <p className={styles.writeClassName}>
                            {book.bookable?.name}
                        </p>
                        <p className={styles.writeChapterName}>
                            {`${book.currentBookChapter.title}: ${book.currentBookChapter.statusToText}`}
                        </p>
                    </div>
                    <div className='card-footer'>
                        <p className={styles.writeSubTitle}>
                            {book.status === BOOK_STATUS.completed
                                ? 'View book'
                                : 'Continue'}
                        </p>
                    </div>
                </Link>
            </div>

            {showDeleteConfirmation && (
                <Modal closeModal={() => setShowDeleteConfirmation(false)}>
                    <div className={styles.deleteConfirmationDialogContainer}>
                        <h3
                            className={
                                styles.deleteConfirmationDialogDescription
                            }
                        >
                            {deleteBookError
                                ? 'The book could not be deleted. Please try again.'
                                : `Are you sure you want to delete this story starter.
                            This will remove the project from your dashboard and
                            delete all students work that has been created for
                            this project.`}
                        </h3>
                        <button
                            disabled={deleteBookLoading}
                            className={styles.deleteConfirmationDialogButton}
                            onClick={() => deleteBook()}
                        >
                            {deleteBookError ? 'Retry Delete' : 'Delete'}
                        </button>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default WriteItem;
